// removed by extract-text-webpack-plugin
module.exports = {"form":"FormPlaceEmbed__form___1KN6C","card":"FormPlaceEmbed__card___3H945","cardFooter":"FormPlaceEmbed__cardFooter___1j5rR","cardButton":"FormPlaceEmbed__cardButton___2hFuq"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FormPlaceEmbed/FormPlaceEmbed.scss
// module id = 1181
// module chunks = 1